module.exports = "<h4 class=\" u-text--sc\">Notes</h4>\n<textarea rows=\"20\" class=\"form-control\"\n    [(ngModel)]=\"notes\"\n    (ngModelChange)=\"onValueChange($event)\"\n    placeholder=\"Enter custom notes here\">\n</textarea>\n<button type=\"button\" class=\"btn--use\"\n    *ngIf=\"needsSaving\"\n    (click)=\"saveChanges()\">Save</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/special/notes/notes.component.html
// module id = ./src/app/special/notes/notes.component.html
// module chunks = main